import toMap from '~/misc/toMap';

export default toMap([
  'MESSAGEPUSH_TOKEN_GET',
  'MESSAGEPUSH_RESET',
  'MESSAGEPUSH_CATALOGS_GET',
  'MESSAGEPUSH_CATALOGS_SELECT',
  'MESSAGEPUSH_CATALOGS_GET_BYPUSH',
  'MESSAGEPUSH_CATALOGS_DELETE',
  'MESSAGEPUSH_CATALOGS_DELETEALL',
  'MESSAGEPUSH_CATALOGS_READ_PREV',
  'MESSAGEPUSH_CATALOGS_READ',
  'MESSAGEPUSH_CATALOGS_READALL',
  'MESSAGEPUSH_MESSAGE_GET',
  'MESSAGEPUSH_MESSAGE_DELETE',
]);



// WEBPACK FOOTER //
// ./src/pages/MessagePush/state/types.js